<div class="landing">
  <section class="landing--intro">
    <div class="container">
      <div class="row">
        <div class="col-md-8 my-auto">
          <h1>{{'home.intro.header' | translate}}</h1>
          <p>{{'home.intro.description' | translate}}</p>
          <h4>{{'home.intro.hashTag' | translate}}</h4>
          <a [routerLink]="'/'+ currentLang +'/auth'">
            <span>{{'home.intro.startNow' | translate}}</span>
            <img src="./assets/images/icons/back.svg" />
          </a>
        </div>
        <div class="col-md-4 my-auto">
          <img src="./assets/images/img_3.svg" />
        </div>
      </div>
    </div>
  </section>
  <section class="landing--steps">
    <div class="how--to">
      <h2>{{'home.info.header' | translate}}</h2>
      <h5>{{'home.info.description' | translate}}</h5>
      <div class="step--one text-left">
        <span class="count">1</span>
        <div class="top--side">
          <h3>{{'home.info.topSide.header' | translate}}</h3>
          <p>{{'home.info.topSide.description' | translate}}</p>
        </div>
        <div class="bottom--side">
          <h5>{{'home.info.bottomSide.header' | translate}}</h5>

          <ul>
            <li>
              <div class="list--ico">
                <i class="icon-checked"></i>
              </div>
              <p>{{'home.info.bottomSide.list.concessionContract' | translate}}</p>
            </li>
            <!--TODO-->
            <!--[ngbTooltip]="disclosureToolTip"-->
            <li>

              <ng-template #disclosureToolTip>
                <div class="hint">
                  <span style="display: block; font-size: 10pt;font-style: italic;color: grey;">
                    {{
"CreateRequest_FranchiseInfo.DisclosureHintTitle"
                    | translate
                    }}
                  </span>
                  <span style="display: block; font-size: 10pt;font-style: italic;color: grey;">
                    {{
"CreateRequest_FranchiseInfo.DisclosureHintRuleNo1"
                    | translate
                    }}
                  </span>
                  <span style="display: block; font-size: 10pt;font-style: italic;color: grey;">
                    {{
"CreateRequest_FranchiseInfo.DisclosureHintRuleNo2"
                    | translate
                    }}
                  </span>

                </div>

              </ng-template>
              <div class="list--ico">
                <i class="icon-checked"></i>
              </div>
              <p>{{'home.info.bottomSide.list.disclosureDocument' | translate}}</p>
            </li>

            <li>

              <div class="list--ico">
                <i class="icon-checked"></i>
              </div>
              <p>{{'home.info.bottomSide.list.documentsRelatedToTheFranchiseAgreement' | translate}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container">
      <ul class="arrest-steps row">
        <li class="col-md-4">
          <span class="count">2</span>
          <div class="title">
            <h3>{{'home.info.steps.secondStep.header' | translate}}</h3>
          </div>
          <div class="content second">
            <p class="step--description">{{'home.info.steps.secondStep.description' | translate}}</p>
            <p class="note">{{'home.info.steps.secondStep.notes' | translate}}</p>
            <a [routerLink]="'/'+ currentLang +'/auth'">
              <span>{{'home.info.steps.secondStep.enterSystem' | translate}}</span>
              <img src="./assets/images/icons/back-w.svg" />
            </a>
          </div>
        </li>

        <li class="col-md-4">
          <span class="count">3</span>
          <div class="title">
            <h3>{{'home.info.steps.thirdStep.header' | translate}}</h3>
          </div>
          <div class="content third">
            <p class="step--description">{{'home.info.steps.thirdStep.description' | translate}}</p>
            <ul>
              <li>
                <div class="list--ico">
                  <i class="icon-checked"></i>
                </div>
                <p>{{'home.info.steps.thirdStep.list.data' | translate}}</p>
              </li>
              <li>
                <div class="list--ico">
                  <i class="icon-checked"></i>
                </div>
                <p>{{'home.info.steps.thirdStep.list.info' | translate}}</p>
              </li>
              <li>
                <div class="list--ico">
                  <i class="icon-checked"></i>
                </div>
                <p>{{'home.info.steps.thirdStep.list.concessionaires' | translate}}</p>
              </li>
              <li>
                <div class="list--ico">
                  <i class="icon-checked"></i>
                </div>
                <p>{{'home.info.steps.thirdStep.list.review' | translate}}</p>
              </li>
              <li>
                <div class="list--ico">
                  <i class="icon-checked"></i>
                </div>
                <p>{{'home.info.steps.thirdStep.list.payment' | translate}}</p>
              </li>
            </ul>
          </div>
        </li>

        <li class="col-md-4">
          <span class="count">
              <i class="icon-checked"></i>
          </span>
          <div class="content">
            <div class="mask">
              <img src="./assets/images/img_2.svg" />
            </div>

            <h3>
              {{'home.info.steps.lastStep.review' | translate}}
            </h3>
            <h3>
              
              {{'home.info.steps.lastStep.print' | translate}}
            </h3>
          </div>
        </li>
      </ul>
    </div>
  </section>
</div>
